namespace Nobox.Common.Pages {
    export interface campaignRes {
        Total?: campaignGroup[];
        Done?: campaignGroup[];
    }
}
